import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ToolManagmentCard from "../../../../../../../common/element/Card/ToolManagmnetCard";
import Button from "../../../../../../../common/element/Buttons";
import EditHrInfoModal from "./EditHr";
import ConfirmationModal from "../../../../../../../common/Common/ConfirmationModal";
import {
    resendHrInvite,
    clearResendHrInvite,
} from "../../../../../../../redux/Managment/mangmentSlice";

import {


    selectResendHrInviteLoading,
    selectResendHrInviteError,
    selectResendHrInviteData,
} from "../../../../../../../redux/Managment/managmentSelector";
import { selectCompanyDetail } from "../../../../../../../redux/Companies/companiesSelector";

const HrInfo = ({ companyData, refresh }) => {
    console.log(companyData.company_id, "companyData in HrInfo");
    const dispatch = useDispatch();
    const companyDetail = useSelector(selectCompanyDetail);
    const [openModal, setOpenModal] = useState(false);
    const [selectedHr, setSelectedHr] = useState(null);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [confirmMessage, setConfirmMessage] = useState({
        title: "",
        message: "",
        isError: false,
    });

    // Redux selectors
    const isResending = useSelector(selectResendHrInviteLoading);
    const resendError = useSelector(selectResendHrInviteError);
    const resendData = useSelector(selectResendHrInviteData);
    console.log(companyDetail, "companyDetail")
    // Handle resend invite success
    useEffect(() => {
        if (resendData) {
            setConfirmMessage({
                title: "Invitation Sent",
                message: resendData.message,
                isError: false,
            });
            setConfirmOpen(true);
            if (refresh) {
                refresh();
            }
            // Clear the state after showing success
            const timer = setTimeout(() => {
                dispatch(clearResendHrInvite());


            }, 3000);

            return () => clearTimeout(timer);
        }
    }, [resendData, dispatch]);

    // Handle resend invite error
    useEffect(() => {
        if (resendError) {
            setConfirmMessage({
                title: "Error",
                message: resendError,
                isError: true,
            });
            setConfirmOpen(true);

            // Clear the error state after showing
            const timer = setTimeout(() => {
                dispatch(clearResendHrInvite());
            }, 3000);

            return () => clearTimeout(timer);
        }
    }, [resendError, dispatch]);

    // Handle resend invite click
    const handleResendInvite = async () => {
        if (!companyData?.company_id) {
            setConfirmMessage({
                title: "Error",
                message: "Company ID not found",
                isError: true,
            });
            setConfirmOpen(true);
            return;
        }

        dispatch(
            resendHrInvite({ companyId: companyData.company_id })
        );
    };

    return (
        <>
            <ToolManagmentCard>
                <div className="py-1 space-y-6">
                    {/* HR Information Section */}
                    <div className="flex justify-between items-center ">
                        <h3 className="font-lato not-italic font-semibold text-[16px] leading-[150%] text-[#101828]">
                            HR Information
                        </h3>
                        <div className="flex items-center gap-3">

                            {(companyData?.hr_user?.invite_sent == false && companyDetail?.hr_user?.isActive == false) ? (

                                /* Resend Invite Button */
                                <button
                                    onClick={handleResendInvite}
                                    disabled={isResending}
                                    className={`relative group p-2 rounded-md flex items-center justify-center transition-all ${isResending
                                        ? "bg-gray-400 cursor-not-allowed"
                                        : "bg-[#FF8E1C] hover:bg-[#e67d19]"
                                        }`}
                                >
                                    {isResending ? (
                                        /* Loader */
                                        <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                                            <path className="opacity-75" fill="currentColor"
                                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                            />
                                        </svg>
                                    ) : (
                                        /* Mail Icon */
                                        <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.9755 5.32331C17.371 5.32331 19.3137 7.26607 19.3137 9.66158C19.3137 12.0572 17.371 14 14.9755 14C12.58 14 10.6372 12.0572 10.6372 9.66158C10.6372 7.26607 12.58 5.32331 14.9755 5.32331ZM1.08628 0H15.7701C16.3636 0 16.8456 0.485597 16.845 1.07617L16.8414 4.68799C16.5526 4.57946 16.2549 4.49658 15.9516 4.44031L15.9543 1.53397L11.2083 5.26408L11.5523 5.60143C11.3031 5.81168 11.0737 6.04433 10.867 6.29646L10.4582 5.89502L8.86873 7.248C8.69899 7.39025 8.43633 7.40734 8.24609 7.25272L6.57753 5.89095L1.48825 10.6637H9.7589C9.81687 10.9672 9.90145 11.2649 10.0116 11.5536L1.07504 11.5539C0.480731 11.5539 0 11.0683 0 10.4774L0.00927964 1.07587C0.0101095 0.484465 0.492274 0 1.08628 0ZM0.890997 9.87897L5.81121 5.27385L0.898805 1.57237L0.890997 9.87897ZM1.60915 0.890317L8.54813 6.24165L15.1146 0.890317H1.60915ZM16.167 8.57839C16.1359 8.55184 16.1043 8.52591 16.0722 8.5006C15.9208 8.38099 15.7633 8.27684 15.6344 8.21305C15.234 8.01516 14.7908 7.99822 14.3982 8.1307C14.0074 8.26269 13.6662 8.54436 13.4683 8.94422C13.2701 9.34456 13.2529 9.78787 13.3852 10.1801C13.453 10.3812 13.5598 10.5669 13.6995 10.7267C13.8393 10.8864 14.0092 11.017 14.1995 11.1109C14.5617 11.291 14.9784 11.3283 15.3669 11.2154C15.7452 11.1055 16.0827 10.859 16.2985 10.5036C16.4028 10.3313 16.6272 10.2761 16.7996 10.3804C16.9719 10.4847 17.0271 10.7091 16.9228 10.8814C16.6084 11.3994 16.1185 11.7579 15.5703 11.9171C15.0257 12.075 14.423 12.0375 13.876 11.7667C13.295 11.4788 12.8848 10.982 12.6922 10.4121C12.5002 9.84336 12.5251 9.20088 12.8125 8.62071C13.1001 8.0399 13.5966 7.63013 14.1662 7.43775C14.7348 7.24574 15.3776 7.2703 15.9579 7.55721C16.1283 7.64167 16.3322 7.77559 16.5246 7.92776L16.6017 7.99007L16.5856 7.69829C16.5747 7.49667 16.7291 7.32401 16.9307 7.31311C17.1324 7.30221 17.3051 7.45665 17.316 7.65827L17.3819 8.84886C17.3976 9.05048 17.247 9.22691 17.0453 9.24267L15.8054 9.34245C15.6038 9.35822 15.4274 9.20752 15.4116 9.00589C15.3958 8.80427 15.5465 8.62788 15.7482 8.61207L16.167 8.57839Z" fill="white" />
                                        </svg>

                                    )}

                                    <span className="absolute bottom-full mb-2 left-1/2 -translate-x-1/2 
        bg-black text-white text-xs px-2 py-1 rounded 
        opacity-0 group-hover:opacity-100 transition-all duration-200 whitespace-nowrap">
                                        {isResending ? "Sending..." : "Resend Invite"}
                                    </span>
                                </button>

                            ) : (companyData?.hr_user?.invite_sent == true && companyData?.hr_user?.isActive == false) ? (

                                /* Invite Sent */
                                <button className="flex items-center gap-1.5 bg-[#E8F2FF] text-[#027AFC] text-sm font-medium px-3 py-1.5 rounded-full cursor-default">
                                    <svg width="13" height="10" viewBox="0 0 13 10" fill="none">
                                        <path d="M1.5 5.36483L4.59346 8.5L11.5 1.5" stroke="#0D6EFD" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    Invite sent
                                </button>

                            ) : (companyData?.hr_user?.isActive == true) ? (

                                /* Active Badge */
                                <div className="flex items-center gap-1 px-2 py-1 bg-[#ECFDF3] rounded-[16px]">
                                    <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                                    <span className="font-lato font-medium text-[12px] text-[#027A48]">
                                        Active
                                    </span>
                                </div>

                            ) : null}

                            {/* EDIT BUTTON */}
                            {companyData?.company_isActive && (
                                <button
                                    onClick={() => {
                                        setSelectedHr(companyData?.hr_user);
                                        setOpenModal(true);
                                    }}
                                    className="px-4 py-1.5 border border-gray-200 rounded-xl bg-white text-gray-700 hover:bg-gray-50 transition font-raleway font-semibold text-[14px]"
                                >
                                    Edit
                                </button>)}
                        </div>

                    </div>
                    <div className="border-b border-gray-200 "></div>
                    <div className="grid grid-cols-2 gap-x-6 gap-y-4">
                        <div className="text-start">
                            <label className="block font-lato font-medium text-[14px] leading-[150%] text-[#98A2B3]">
                                HR Name
                            </label>
                            <p className="font-lato font-medium text-[16px] leading-[150%] text-[#101828] mb-0">
                                {companyData?.hr_user?.first_name}{" "}
                                {companyData?.hr_user?.last_name}
                            </p>
                        </div>

                        <div className="text-start">
                            <label className="block font-lato font-medium text-[14px] leading-[150%] text-[#98A2B3] ">
                                HR Email
                            </label>
                            <p className="font-lato font-medium text-[16px] leading-[150%] text-[#101828] mb-0  break-all ">
                                {companyData?.hr_user?.email}
                            </p>
                        </div>

                        <div className="text-start">
                            <label className="block font-lato font-medium text-[14px] leading-[150%] text-[#98A2B3]">
                                HR Number
                            </label>
                            <p className="font-lato font-medium text-[16px] leading-[150%] text-[#101828] mb-0">
                                {companyData?.hr_user?.mobile_number}
                            </p>
                        </div>
                        <div className="text-start">
                            <label className="block font-lato font-medium text-[14px] leading-[150%] text-[#98A2B3]">
                                HR Gender
                            </label>
                            <p className="font-lato font-medium text-[16px] leading-[150%] text-[#101828] mb-0 capitalize">
                                {companyData?.hr_gender || 'N/A'}
                            </p>
                        </div>
                    </div>
                </div>
            </ToolManagmentCard>

            <EditHrInfoModal
                dialogOpen={openModal}
                onDialogClose={() => setOpenModal(false)}
                hrData={selectedHr}
                companyData={companyData}
                onSubmit={(updatedData) => {
                    console.log("Updated HR:", updatedData);
                    // call API or update state here
                }}
            />

            <ConfirmationModal
                dialogOpen={confirmOpen}
                onDialogClose={() => setConfirmOpen(false)}
                title={confirmMessage.title}
                message={confirmMessage.message}
                isError={confirmMessage.isError}
            />
        </>
    );
};

export default HrInfo;